interface SmsNotifyDialog {
  visible: boolean
  type: number
  clientId: string
  module: string
  activityId: string
}
interface SetDialogParams {
  visible: boolean
  step: number
}
interface CustomerDataParams {
  [props: string]: any
}

interface DiagnosisDataParams {
  stage1: Array<object>
  stage2: Array<object>
}

interface InviteDataParams {
  clientId: string
  topicId: number
  stage: number
  recordId: string
}

interface BatchTopic {
  topicId: number
  recordId: string | undefined
}

interface InviteDialogDataParams {
  clientId: string
  stage: number
  clear?: boolean
  topicId?: number
  recordId?: string
  type?: string // shareActivity
  activityId?: string
  batchTopic: Array<BatchTopic>
}

interface State {
  diagnosisThemeDialogVisible: boolean
  createActivityDialogVisible: boolean
  inviteDialogVisible: boolean
  addCustomerDialog: SetDialogParams
  editDialogVisible: boolean
  traceDialogVisible: boolean
  customerData: CustomerDataParams
  diagnosisData: DiagnosisDataParams
  inviteData: InviteDataParams
  inviteDialogData: InviteDialogDataParams
  isRefreshClientList: boolean
  isRefreshActivityList: boolean
  smsNotifyDialog: SmsNotifyDialog
}

export default {
  namespaced: true,
  state: {
    // 选择评估主题弹窗
    diagnosisThemeDialogVisible: false,
    // 创建活动弹窗
    createActivityDialogVisible: false,
    // 评估邀约弹窗
    inviteDialogVisible: false,
    // 添加客户弹窗
    addCustomerDialog: {
      visible: false,
      step: 0,
    },
    // 修改客户弹窗
    editDialogVisible: false,
    // 跟进弹窗
    traceDialogVisible: false,
    // 客户数据
    customerData: {
      mobilePhone: '',
      name: '',
      gender: null,
      birth: '',
      areacode: null,
      school: '',
      grade: null,
      parent1: '',
      relation1: null,
      mobilePhone1: '',
      parent2: '',
      relation2: null,
      mobilePhone2: '',
    },
    // 评估列表内容
    diagnosisData: {
      stage0: [],
      stage1: [],
      stage2: [],
    },
    // 邀约评估
    inviteData: {
      clientId: '',
      topicId: 0,
      stage: 0,
      recordId: '',
    },
    // 组合邀约评估
    inviteDialogData: {
      clientId: '',
      stage: 0,
      batchTopic: [],
    },
    smsNotifyDialog: {
      visible: false,
      type: 0,
      clientId: '',
      module: 'recruit',
    },
    // 是否刷新转付费客户列表
    isRefreshClientList: false,
    // 是否刷新活动列表
    isRefreshActivityList: false,
  },
  getters: {},
  mutations: {
    // 设置短信dialog
    setSmsNotifyDialog(state: State, payload: SmsNotifyDialog) {
      // activityId默认值未空
      if (payload.activityId === undefined) {
        payload.activityId = ''
      }
      state.smsNotifyDialog = {
        ...state.smsNotifyDialog,
        ...payload,
      }
    },
    setDiagnosisThemeDialogVisible(state: State, payload: boolean) {
      state.diagnosisThemeDialogVisible = payload
    },
    setCreateActivityDialogVisible(
      state: State,
      payload: {
        visible: boolean
        clear: boolean
      }
    ) {
      state.createActivityDialogVisible = payload.visible
      // 弹窗关闭时，还原数据
      if (!payload.visible && payload.clear) {
        state.inviteData = {
          clientId: '',
          topicId: 0,
          stage: 0,
          recordId: '',
        }
      }
    },
    setInviteDialogVisible(state: State, payload: boolean) {
      state.inviteDialogVisible = payload
      // 弹窗关闭时，还原数据
      if (!payload) {
        state.inviteData = {
          clientId: '',
          topicId: 0,
          stage: 0,
          recordId: '',
        }
      }
    },
    setAddCustomerDialog(state: State, payload: SetDialogParams) {
      state.addCustomerDialog = {
        ...state.addCustomerDialog,
        ...payload,
      }
    },
    setEditCustomerDialogVisible(state: State, payload: boolean) {
      state.editDialogVisible = payload
    },
    setTraceDialogVisible(state: State, payload: boolean) {
      state.traceDialogVisible = payload
    },
    setCustomerData(state: State, payload: CustomerDataParams) {
      state.customerData = payload
    },
    setDiagnosisData(state: State, payload: DiagnosisDataParams) {
      state.diagnosisData = payload
    },
    setInviteData(state: State, payload: InviteDataParams) {
      state.inviteData = {
        ...state.inviteData,
        ...payload,
      }
    },
    setInviteDataDialog(state: State, payload: InviteDialogDataParams) {
      const { topicId, stage = 0, recordId, clientId, clear = false, activityId = '', type } = payload
      if (clientId !== undefined) {
        state.inviteDialogData.clientId = clientId
      }
      if (clear) {
        state.inviteDialogData.batchTopic = []
      }
      if (type !== undefined) {
        state.inviteDialogData.type = type
      }
      state.inviteDialogData.activityId = activityId
      state.inviteDialogData.stage = stage
      const checked = state.inviteDialogData.batchTopic.find(
        (item) => item.topicId === topicId && item.recordId === recordId
      )
      if (topicId) {
        if (checked) {
          state.inviteDialogData.batchTopic = state.inviteDialogData.batchTopic.filter(
            (item) => !(item.topicId === topicId && item.recordId === recordId)
          )
        } else {
          state.inviteDialogData.batchTopic.push({ topicId, recordId })
        }
      }
    },
    setIsRefreshClientList(state: State, payload: boolean) {
      state.isRefreshClientList = payload
    },
    setIsRefreshActivityList(state: State, payload: boolean) {
      state.isRefreshActivityList = payload
    },
  },
  actions: {},
}
